module.exports = __webpack_public_path__ + "img/28.2333ff3c.png";